import { RoomTypes } from '@weblite/ts-action/room'
import { useRoom } from '$logic/room/react-hook'
import { UserListItemWithStatus } from '$common/room-list-search/user-list-item-with-status'
import { HallListItemWithStatus } from '$common/room-list-search/hall-list-item-with-status'
import { WappRoomListItemWithStatus } from '$common/room-list-search/wapp-room-list-item-with-status'
import { PrivateSpaceListItemWithStatus } from '$common/room-list-search/private-space-list-item-with-status'
import { nothing } from '$func/utils'
import { UserListItemSkeleton } from '$common/user-list-item'
import { addToRecentSearch } from '$logic/room-list/room-list-search.service'
import { openRoom } from '$logic/opened-room'

interface Props {
  roomId: string
  onSecondaryActionIconClick?: () => void
}

const componentMapper: Record<RoomTypes, any> = {
  CHANNEL: HallListItemWithStatus,
  GROUP: HallListItemWithStatus,
  PV: UserListItemWithStatus,
  WAPP_ROOM: WappRoomListItemWithStatus,
  PRIVATE_SPACE: PrivateSpaceListItemWithStatus,
}

export function RoomListItemWithStatus({
  roomId,
  onSecondaryActionIconClick = nothing,
}: Props) {
  const room = useRoom(roomId)

  if (!room) return <UserListItemSkeleton />

  const { type } = room

  const onClick = () => {
    openRoom(roomId)
    addToRecentSearch({ id: roomId, type: 'ROOM' })
  }

  const Component = componentMapper[type]

  return (
    <Component
      chatId={roomId}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
      onClick={onClick}
    />
  )
}
